import React from 'react'
import Helmet from 'react-helmet'
import ReactHtmlParser from 'react-html-parser'

const Meta = (props) => {
  let metaTags

  if (props.meta && props.meta.length) {
    metaTags = props.meta.map((tag, idx) => {
      let attributes = ''
      let innerContent = (tag.innerContent) ? tag.innerContent : ''

      if (tag.attributes) {
        attributes = Object.keys(tag.attributes).map((key) => {
          return (
            `${key}="${tag.attributes[key]}"`
          )
        }).join('')
      }

      return (
        `<${tag['tag']} ${attributes}>${innerContent}</${tag['tag']}>`
      )
    }).join('')
  }
  let tags = ReactHtmlParser(metaTags)

  return (
    <Helmet
      encodeSpecialCharacters
      htmlAttributes={{ lang: 'en-US' }}
      defaultTitle='LittleBox'
    >
      {tags}
    </Helmet>
  )
}

export default Meta



// WEBPACK FOOTER //
// ./src/components/MetaHandler/index.js